var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "donutChart",
      style: { backgroundImage: this.calculatedBackgroundImage },
    },
    [
      _c(
        "div",
        {
          staticClass: "donutChart__rating",
          class: { no_data: _vm.rating === 0 },
        },
        [_vm._v(_vm._s(_vm.rating > 0 ? _vm.rating.toFixed(1) : "データなし"))]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }